exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".news-newscategoryexplorer-component{padding-bottom:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/pages/news/newscategoryexplorer.scss
// module id = 1024
// module chunks = 0